import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DirectoryBar } from '../components/DirectoryBar';
import { ProductCard } from '../components/ProductCard';
import {
  getBookmarks,
  getProductCustomList,
  getProductDetail,
  postBookmark,
} from '../apis/products';
import { ProductQuery } from '../types/types';
import { H3 } from '../components/H3';
import { nToast } from '../plugins/reactToast';
import injectSizesIntoProductList from '../utils/injectSizesIntoProductList';
import { ItemEventProperties } from '../types/amplitudeEventProperties';
import { Bridge } from '../plugins/bridge';
import { BRAZE_EVENT } from '../constants/braze';

export const MyLikedPage = () => {
  const { push } = useHistory();
  const [products, setProducts] = useState<ProductQuery[]>([]);
  const mounted = useRef(false);

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    if (!mounted.current) mounted.current = true;
    else {
      Bridge.sendAmplitude('wishlist_page_viewed', {
        item_id: products.map((product) => { return product.productId }),
        item_name: products.map((product) => { return product.productName }),
        item_category: products.map(() => { return '?' }),
        item_color: products.map((product) => { return product.color }),
        item_gender: products.map(() => { return '?' }),
        item_price: products.map((product) => { return Number(product.initialPrice) }),
        item_discount_rate: products.map((product) => { return Number(product.discountedRate) }),
        item_discount_price: products.map((product) => { return Number(product.currentPrice) })
      });
    }
  }, [products]);

  const getList = () => {
    getBookmarks().then(r => {
      if (r && r.data) {
        const data = r.data.payload;
        const list: number[] = [];
        const likeProductIdsStr = localStorage.getItem('car_likeProductIds');

        data.forEach(item => list.push(item.id));
        if (list.length > 0) {
          getProductCustomList(list)
              .then(r => injectSizesIntoProductList(r.data.payload))
              .then(payload => {
              if (!likeProductIdsStr) {
                setProducts(payload || [])
                return;
              }
              const likeProductIds: string[] = JSON.parse(
                likeProductIdsStr,
              );

              list.forEach(it =>
                likeProductIds.indexOf(it.toString()) == -1 &&
                likeProductIds.push(it.toString())
              )
              setProducts(
                payload?.sort(
                  (a, b) =>
                    likeProductIds.indexOf(a.productId.toString()) -
                    likeProductIds.indexOf(b.productId.toString())
                ) ?? []
              );
            }).catch(e => console.log(e));
        } else {
          setProducts([])
        }
      }
    }).catch(e => console.log(e));
  };

  const handleDelete = (productId: number) => {
    var wishlist_count = 0;
    getBookmarks().then(r => { if (r && r.data) { wishlist_count = r.data.payload.length } })

    getProductDetail(productId).then(item => {
      var itemProperties = {
        item_id: [String(item.data.payload.productId)],
        item_name: [String(item.data.payload.productName)],
        item_category: [String(item.data.payload.categoryCode)],
        item_color: [String(item.data.payload.productInfo.color)],
        item_gender: [String(item.data.payload.genderCode)],
        item_price: [Number(item.data.payload.initialPrice)],
        item_discount_price: [Number(item.data.payload.currentPrice)],
        item_discount_rate: [Number(item.data.payload.discountedRate)]
      }
      Bridge.sendAmplitude('setUserProperties#total_wishlist_items_count', wishlist_count - 1);
      Bridge.sendAmplitude('item_deleted_from_wishlist', itemProperties);
      Bridge.sendBraze(BRAZE_EVENT.DELETED_FROM_WISHLIST, itemProperties);
    });

    postBookmark({ targetId: productId, targetType: 'PRODUCT' }).then(r => {
      nToast('관심 상품이 삭제되었습니다');
      getList();

      const likeProductIdsStr = localStorage.getItem('car_likeProductIds');
      if (!likeProductIdsStr) {
        return
      }
      const likeProductIds: string[] = JSON.parse(
        likeProductIdsStr,
      );

      localStorage.setItem(
        'car_likeProductIds',
        JSON.stringify([
          ...likeProductIds
            .filter(_productId => _productId !== String(productId))
            .slice(0, 15),
        ]),
      );

    }).catch(e => console.log(e));
  };

  return (
    <>
      <DirectoryBar text="관심상품" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-10 -mx-2.5 md:-mx-0">
        {products.length === 0 && <h4 data-aos="fade-in" data-aos-delay="900"><H3 className="pb-96 mb-96 ml-2">관심상품이 없습니다.</H3></h4>}
        {products.map((product, index) => (
          <ProductCard
            key={index}
            product={product}
            onClick={() => push(`/product/${product.productId}`)}
            deleteButton={handleDelete}
          />
        ))}
      </div>
    </>
  );
};
